import React from 'react';
import { Authenticator } from '@aws-amplify/ui-react';
import { Auth } from 'aws-amplify';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Provider } from 'react-redux';

import DataGridPage from './componets/datagrid/datagridpage';
import DesignDashboard from './componets/designDashboard';
import AcquisitionsPage from './componets/acquisitionsPage';
import HomeLifecycleKanban from './componets/homeLifecycleKanban';
import LandDevelopmentKanban from './componets/landDevelopmentKanban';
import ManufacturingDashboard from './componets/manufacturingDashboard';
import Map from './componets/map/map';
import PropertyPipelineKanban from './componets/propertyPipelineKanban';
import Scout from './componets/scout/scout';
import SiteOpsDashboard from './componets/siteOpsDashboard';
import { RequireAuth } from './guards/RequireAuth';
import { RequireAro } from './guards/RequireAro';
import { Login } from './componets/login';
import TermsOfUse from './componets/termsOfUse';
import { store } from './store/store';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/js/bootstrap.min.js';
import './App.css';
import '@aws-amplify/ui-react/styles.css';

import { LicenseInfo } from '@mui/x-license';
import RealEstateMarketDashboard from './componets/realEstateMarketDashboard';

LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_LICENSE);

Auth.configure({
    Auth: {
    // REQUIRED - Amazon Cognito Region
        region: 'us-east-1',

        // OPTIONAL - Amazon Cognito User Pool ID
        userPoolId: 'us-east-1_TFh8c2imx',

        // OPTIONAL - Amazon Cognito Web Client ID (26-char alphanumeric string)
        userPoolWebClientId: '3o5a4vta1g3ibh2see9kh6nm14',
    },
});

function MyRoutes() {
    return (
        <BrowserRouter>
            <Routes>
                <Route
                    path="/"
                    index
                    element={
                        <RequireAuth>
                            <Map path={'/'} />
                        </RequireAuth>
                    }
                />
                <Route
                    path="/market"
                    element={
                        <RequireAuth>
                            <RealEstateMarketDashboard />
                        </RequireAuth>
                    }
                />
                <Route
                    path="/kanban"
                    element={
                        <RequireAuth>
                            <PropertyPipelineKanban path={'/kanban'} />
                        </RequireAuth>
                    }
                />
                <Route
                    exact
                    path="/property/:id"
                    element={
                        <RequireAuth>
                            <Scout path="/property/:id" />
                        </RequireAuth>
                    }
                />
                <Route path="/terms" element={<TermsOfUse />} />
                <Route
                    path="/datagrid"
                    element={
                        <RequireAuth>
                            <RequireAro>
                                <DataGridPage />
                            </RequireAro>
                        </RequireAuth>
                    }
                />
                <Route
                    path="/acquisitions"
                    element={
                        <RequireAuth>
                            <RequireAro>
                                <AcquisitionsPage />
                            </RequireAro>
                        </RequireAuth>
                    }
                />
                <Route
                    path="/land"
                    element={
                        <RequireAuth>
                            <RequireAro>
                                <LandDevelopmentKanban />
                            </RequireAro>
                        </RequireAuth>
                    }
                />
                <Route
                    path="/design"
                    element={
                        <RequireAuth>
                            <RequireAro>
                                <DesignDashboard />
                            </RequireAro>
                        </RequireAuth>
                    }
                />
                <Route
                    path="/manufacturing"
                    element={
                        <RequireAuth>
                            <RequireAro>
                                <ManufacturingDashboard />
                            </RequireAro>
                        </RequireAuth>
                    }
                />
                <Route
                    path="/siteops"
                    element={
                        <RequireAuth>
                            <RequireAro>
                                <SiteOpsDashboard />
                            </RequireAro>
                        </RequireAuth>
                    }
                />
                <Route
                    path="/lifecycle"
                    element={
                        <RequireAuth>
                            <RequireAro>
                                <HomeLifecycleKanban />
                            </RequireAro>
                        </RequireAuth>
                    }
                />
                <Route path="/login" element={<Login />} />
            </Routes>
        </BrowserRouter>
    );
}

function App() {
    return (
        <Authenticator.Provider>
            <Provider store={store}>
                <MyRoutes />
            </Provider>
        </Authenticator.Provider>
    );
}

export default App;
